import { Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { ActionIcon } from "@mantine/core";
import { HttpClientError } from "../../../providers/HttpClient";
import { queryClient } from "../../../App";
import ConfirmDeleteModel from "../../../themes/elements/ConfirmDeleteModel";
import useDeleteSurveyApiService from "../services/api/DeleteSurveyApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type DeleteSurveyActionIconProps = {
  id: number;
};

const DeleteSurveyActionIcon: React.FC<DeleteSurveyActionIconProps> = ({
  id,
}) => {
  const [opened, setOpened] = useState(false);
  const { isLoading, isSuccess, isError, error, mutate, data } =
    useDeleteSurveyApiService();
  const { showToast } = useToasts();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "survey_delete_failed",
        data: { message: HttpClientError(error) },
      });

      setOpened(false);
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess)
      // eslint-disable-next-line no-console
      queryClient.invalidateQueries(["ListSurveyApiService", 1]).then(() => {
        showToast({ strapiId: "survey_delete_success" });

        setOpened(false);
      });
  }, [isSuccess, data]);

  return (
    <>
      <ConfirmDeleteModel
        isLoading={isLoading}
        label="survey"
        onClose={() => setOpened(false)}
        onConfirm={() => mutate(id)}
        opened={opened}
      />

      <ActionIcon onClick={() => setOpened(true)}>
        <Trash2 size={18} />
      </ActionIcon>
    </>
  );
};

export default DeleteSurveyActionIcon;
